<script lang="ts">
  import { Button, Col } from "sveltestrap";
  import { Filefilter } from "../../../utils/Constant/Constant";
  import data from "../../../Data/FileManager/FileManager.json"
  import FeatherIcon from "svelte-feather-icon";
  import Card from "../../Core/Card.svelte";
  import PricingPlan from "./PricingPlan.svelte";
  import Storage from "./Storage.svelte";

  let isOpen:boolean = false
  // Left Sidebar open and close
  function handleSidebar(){
    isOpen = !isOpen
  }
</script>
  
<Col xl="3" class="box-col-3 pe-0">
    <div class="job-sidebar">
      <Button color="primary" 
        class="job-toggle"
        on:click={handleSidebar}>{Filefilter}</Button >
      <div 
      class="job-left-aside custom-scrollbar"
      class:open = {isOpen === true}>
        <div class="file-sidebar">
          <Card>
            <div slot="contentbody">
              <ul>
                {#each data.filedata as fileItem }
                  <li>
                    <div class="btn {fileItem.class}">
                      <FeatherIcon icon={fileItem.icon} />{fileItem.title}
                    </div>
                  </li>
                {/each}
              </ul>
              <hr />
              <Storage />
              <hr />
              <PricingPlan />
            </div>
          </Card>
        </div>
      </div>
    </div>
</Col>
  